"use client"
import styled from "@emotion/styled"
import { GetPageQuery } from "apollo"
import { useState } from "react"
import { BlockRenderer } from "utils"
import { findProperty } from "utils/findProperty"
import ContactUsMain from "./ContactUsMain"

const StyledContact = styled.div``

type Props = {
  data: GetPageQuery
}

function ContactUs({ data }: Props) {
  const [selectedValue, setSelectedValue] = useState(0)

  const components = {
    contactPageInfo: ContactUsMain,
  }

  return (
    <StyledContact>
      {findProperty(data.page, "blocks")?.blocks?.map(
        // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
        (block: any, index: number) => (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            props={
              block.blockType === "contactPageInfo"
                ? {
                    setSelectedValue: setSelectedValue,
                    selectedValue: selectedValue,
                  }
                : {}
            }
          >
            {null}
          </BlockRenderer>
        )
      )}
    </StyledContact>
  )
}

export default ContactUs
